import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import AdminLayout from './admin/components/AdminLayout';
import {
  DashboardPage,
  UsersPage,
  CouponsPage,
  TransactionsPage,
  GamesPage,
  SettingsPage
} from './admin/pages';
import LoginPage from './admin/pages/LoginPage';

function App() {
  return (
    <Router>
      <AdminLayout>
        <Routes>
          <Route path="/admin/dashboard" element={<DashboardPage />} />
          <Route path="/admin/users" element={<UsersPage />} />
          <Route path="/admin/coupons" element={<CouponsPage />} />
          <Route path="/admin/transactions" element={<TransactionsPage />} />
          <Route path="/admin/games" element={<GamesPage />} />
          <Route path="/admin/settings" element={<SettingsPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/games" element={<GamesPage />} />
          <Route path="*" element={<Navigate to="/admin/dashboard" replace />} />
        </Routes>
      </AdminLayout>
    </Router>
  );
}

export default App;
